import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

interface EmptyWebsiteIconProps extends SvgProps {
  bordersColor?: string
  mainColor?: string
}

export const EmptyWebsiteIcon = ({
  bordersColor,
  mainColor,
  ...props
}: EmptyWebsiteIconProps) => {
  return (
    <svg
      width="238"
      height="208"
      viewBox="0 0 238 208"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <rect
        width="76.1054"
        height="140.014"
        rx="20"
        transform="matrix(0.966022 -0.25846 0.259178 0.96583 0 68.3848)"
        fill={mainColor}
        fill-opacity="0.08"
      />
      <rect
        width="76.1054"
        height="140.014"
        rx="20"
        transform="matrix(0.966022 0.25846 -0.259178 0.96583 164.48 46.3857)"
        fill={mainColor}
        fill-opacity="0.08"
      />
      <rect
        x="61"
        y="2"
        width="116.167"
        height="204"
        rx="22"
        fill={mainColor}
        fill-opacity="0.08"
        stroke={bordersColor}
        stroke-width="4"
      />
      <rect
        x="74.7891"
        y="34.9912"
        width="24.0178"
        height="24.0178"
        rx="12.0089"
        fill={bordersColor}
      />
      <rect
        x="74.7812"
        y="69"
        width="67.0996"
        height="10"
        rx="2"
        fill={bordersColor}
      />
      <rect
        x="74.7812"
        y="83"
        width="80.1189"
        height="10"
        rx="2"
        fill={bordersColor}
      />
    </svg>
  )
}
